import { RouteLocationNormalized } from 'vue-router'

export enum MiddlewareAction {
  LOGOUT = 'logout',
}

export type middlewareInstructions = {
  to: {
    name: string // return empty string when there is no redirection
  }
  actions?: MiddlewareAction
}

export type middlewareContext = {
  to: RouteLocationNormalized
  from: RouteLocationNormalized
}
